import { render, staticRenderFns } from "./CounselView.vue?vue&type=template&id=18e8d880&"
import script from "./CounselView.vue?vue&type=script&lang=js&"
export * from "./CounselView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports